<template>
  <div class="account-settings-content tab-pane fade" id="company" role="tabpanel" aria-labelledby="company-tab">
    <h2>{{$t('account_settings.company.header')}}</h2>
    <send-invitation ref="sendInvitationModal"></send-invitation>
    <a href="#" class="btn btn-primary float-right" @click.prevent="$refs.sendInvitationModal.openModal()">{{$t('account_settings.send_invitation.new_user')}}</a>
    <div class="organization-users">
      <div class="nav-tabs-wrapper">
        <ul role="tablist" class="nav nav-tabs">
          <li class="nav-item">
            <a aria-selected="true" role="tab" data-toggle="tab" href="#users"
                                  class="nav-link active show">{{$t('account_settings.company.users', {count: users.length})}}</a>
          </li>
          <li class="nav-item">
            <a aria-selected="true" role="tab" data-toggle="tab" href="#pending-invitations"
                                  class="nav-link show">{{$t('account_settings.company.pending_invitations', {count: invitations.length})}}</a>
          </li>
        </ul>
      </div>
      <div class="tab-content">
        <div id="users" role="tabpanel" class="active tab-pane">
          <div class="table_wrapper">
            <table class="table">
              <thead>
              <tr>
                <th>{{$t('account_settings.company.table.name')}}</th>
                <th>{{$t('account_settings.company.table.email')}}</th>
                <th>{{$t('account_settings.company.table.status')}}</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for='user in users' :key='user.id'>
                <td>
                  {{ user.full_name }}
                </td>
                <td>
                  {{ user.email }}
                </td>
                <td v-if="user.status === 'active'">
                  <i :class="`fas fa-circle ${ statusClass(user.status) }`" />
                  {{ statusText(user.status) }}
                </td>
                <td v-else-if="user.status === 'inactive'">
                  <i :class="`fas fa-circle ${ statusClass(user.status) }`" />
                  {{ statusText(user.status) }}
                </td>
                <td v-else>
                  <i :class="`fas fa-circle ${ statusClass(user.status) }`" />
                  {{ statusText(user.status) }}
                </td>
                <td v-if="creator.id === user.id" class="action-column">
                  {{$t('account_settings.company.owner_info')}}
                </td>
                <td v-else class="action-column">
                  <a v-if="user.status === 'active'" @click.prevent="updateCompanyUser(user.id, 'inactive')" href="" class="btn btn-neutral">{{ $t('account_settings.deactivate_user') }}</a>
                  <a v-else-if="user.status === 'inactive'" @click.prevent="updateCompanyUser(user.id, 'active')" href="" class="btn btn-neutral">{{ $t('account_settings.activate_user') }}</a>
                </td>
              </tr>
              <tr v-if="users.length === 0" class="empty-row">
                <td colspan="4">
                  {{$t('account_settings.company.no_users')}}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div id="pending-invitations" role="tabpanel" class="tab-pane">
          <div class="table_wrapper">
            <table class="table">
              <thead>
                <tr>
                  <th>{{$t('account_settings.company.table.email')}}</th>
                  <th>{{$t('account_settings.company.table.sent_on')}}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="invitations.length === 0" class="empty-row">
                  <td colspan="3">
                    {{$t('account_settings.company.no_invitatons')}}
                  </td>
                </tr>
                <tr v-for='user in invitations'>
                  <td>{{ user.email }}</td>
                  <td>{{ formatDate(user.created_at) }}</td>
                  <td>
                    <a @click.prevent="resendInvitation(user.id)" href="" class="btn btn-neutral">{{ $t('account_settings.resend_invitation') }}</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _sendInvitation from "../account_settings/_send-invitation";

  export default {
    components: {
      'send-invitation': _sendInvitation
    },
    computed: {
      organization() {
        return this.state.organization || {}
      },
      creator() {
        return this.organization.creator || {}
      },
      users() {
        return this.organization.users || []
      },
      invitations() {
        return this.users.filter(({status}) => status === 'pending')
      }
    },
    methods: {
      updateCompanyUser(userId, status) {
        this.store.updateCompanyUser(userId, { user: { status: status } }).then(() => {
          this.store.getCurrentOrg()
          this.$toastr.success('User successfully deactivated')
        })
      },
      resendInvitation(userId) {
        this.store.resendInvitation(userId).then(() => {
          this.$toastr.success(this.$t('account_settings.invitation_sent'))
        })
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "../../styles/user_profile"
</style>
